import { ChevronRightIcon } from '@heroicons/react/24/outline';
import { usePageTitle } from '@src/contexts';
import { useTheme } from '@src/theme';
import { Breadcrumb as AntDBreadcrumb } from 'antd';
import { useNavigate } from 'react-router-dom';

export function Breadcrumb() {
    const { theme } = useTheme();
    const { breadcrumbs } = usePageTitle();
    const navigate = useNavigate();

    return (
        <AntDBreadcrumb
            className="flex items-center space-x-1"
            separator={
                <span className="flex items-center">
                    <ChevronRightIcon
                        className="w-4 h-4 relative top-[3px]"
                        style={{ color: theme.semantic.textPrimary }}
                    />
                </span>
            }
        >
            {breadcrumbs.map(({ title, path }, index) => {
                const isLast = index === breadcrumbs.length - 1;

                return (
                    <AntDBreadcrumb.Item key={index}>
                        <span className="flex items-center font-normal">
                            {isLast || !path ? (
                                <span
                                    style={{
                                        color: theme.semantic.textPrimary,
                                    }}
                                >
                                    {title}
                                </span>
                            ) : (
                                <a
                                    style={{
                                        color: theme.semantic.textPrimary,
                                        opacity: 0.4,
                                    }}
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(path);
                                    }}
                                >
                                    {title}
                                </a>
                            )}
                        </span>
                    </AntDBreadcrumb.Item>
                );
            })}
        </AntDBreadcrumb>
    );
}
